<template>
    <div id="js-product-list" v-if="!loading && items.length">
        <div class="products">
            <div class="product_list grid  product-list-default ">
                <div class="row">
                    <!-- <ItemCard v-for="(item, i) in items" :key="i" :item="item" :loading="loading" class="col-sp-12 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-4 cursor-pointer"/> -->
                    <ItemCard v-for="(item, i) in items" :key="i" :item="item" :loading="loading" class="col-sp-12 col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 cursor-pointer"/>
                </div>
            </div>
        </div>
        <nav class="pagination">
            <div class="col-xs-12 col-md-6 col-lg-4 text-md-left text-xs-center">
                Showing {{Number((size * currentPage) - (size - 1))}}-{{size * currentPage - (size - items.length)}} of {{totalItems}} item(s)
            </div>
            <!-- <div class="col-xs-12 col-md-6 col-lg-8 grid-pagination">
                <v-pagination v-show="totalPages > 1" v-model="currentPage" :pages="Math.ceil(totalPages)" :range-size="0"
                    active-color="#000" @update:modelValue="onUpdatePage(currentPage)" />
               
            </div> -->
        </nav>
    </div>
    <div id="js-product-list" v-else-if="loading">
        <div class="products">

            <div class="product_list grid  product-list-default ">
                <div class="row">
                    <ItemShimmer v-for="(val, i) in 9" :key="i" class="col-sp-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

const router = useRouter();
const route = useRoute();

const props = defineProps({
    items: {
        type: Array,
        default: () => [],
    },
    totalItems: {
        type: Number,
        default: 0,
    },
    totalPages: {
        type: Number,
        default: 0,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    isGrid: {
        type: Boolean,
        default: false,
    },
    size: {
        type: Number,
        default: 0,
    },
    currentPage: {
        type: Number,
        default: 0,
    },
});
const emit = defineEmits(["on-update-page"]);
const itemsRef = ref([]);
// const currentPage = ref(1);
const pageSize = ref(20); // this value will be set from request size
watch(
    () => props.items,
    () => {
        if (props.items && props.items.length > 0) {
            let arrayOfObject = [];
            props.items.forEach((item) => {
                if (item && item.id.length > 0) {
                    if (
                        arrayOfObject.filter((i) => i.id == item.id).length <= 0
                    ) {
                        arrayOfObject.push(item);
                    }
                }
            });
            itemsRef.value = arrayOfObject;
        }
    }
);
// const
const onUpdatePage = (page) => {
    emit("on-update-page", page);
};
</script>

<style lang="scss">
.grid-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .Page {
        height: 47px;
        width: 47px;
        font-weight: 700;
        border-radius: 10px;
        margin-right: 10px;
        box-shadow: 0px 2px 8px 0px #e6e6e6;
    }

    .Page-active {
        height: 40px !important;
        width: 40px !important;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        border-radius: 100%;
        background-color: #F69320 !important;
    }
}

@media screen and (min-width: 0px) and (max-width: 767px) {
    .grid-pagination {
        row-gap: 15px;

        .Page {
            height: 30px;
            width: 30px;
        }

        .Page-active {}
    }
}
</style>
